import { APIUrls } from "../../Constants/ApiUrls";
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const TestAlarmController = {
  // cosa succede con una prova su questo dispositivo: destinatari, sensori provabili e motivi
  GetInfo: async (
    sentinelId: number,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.TEST_ALARMS.TEST_ALARM_INFO.replace(
      ":sentinelId",
      String(sentinelId)
    );
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  // crea un allarme vero segnato PROVA sul sensore scelto
  Send: async (
    sentinelId: number,
    sensorId: number,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.TEST_ALARMS.TEST_ALARM_SEND.replace(
      ":sentinelId",
      String(sentinelId)
    ).replace(":sensorId", String(sensorId));
    request.method = "POST";
    request.payload = {};
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default TestAlarmController;
